import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { selectInputHandler } from './input.helpers';

const propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
};

const TextFieldBlurWidget = props => {
	const { onChange, onBlur, value, ...otherProps } = props;
	const handleChange = selectInputHandler(onBlur);
	const [inputValue, setInputValue] = useState(value);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	function inputChange(e) {
		setInputValue(e.target.value);
	}

	return (
		<TextField
			value={inputValue}
			onBlur={handleChange}
			onChange={inputChange}
			variant="filled"
			{...otherProps}
			key={value}
		/>
	);
};

TextFieldBlurWidget.propTypes = propTypes;

export default TextFieldBlurWidget;
